import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Search/SearchResults/searchResults.container"
    ).then((module) => ({ default: module.SearchResults }))
);
